export default {
	title: '采集定义',
	actions: {
		add: '新增',
		edit: '修改',
		copy: '复制',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		getSuccess: '获取成功',
		sendSuccess: '下发成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		terminalNumber: '终端编号',
		configName: '采集配置名称',
		selectTerminal: '选择终端',
		config: '采集配置',
		placeholder: {
			terminalNumber: '请输入终端编号',
			configName: '请输入采集配置名称',
			selectTerminal: '请选择终端',
			config: '请选择采集配置'
		}
	},
	table: {
		terminalNumber: '终端编号',
		configName: '采集配置',
		sleepTimeDisplay: '休眠时间',
		specFreqDisplay: '特征值频率',
		updateTime: '最后更新'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		copy: '复制',
		cancel: '取消',
		confirm: '确定',
		terminalInfo: '终端信息',
		selfCheck: '终端自检',
		checkInfo: '自检信息',
		getConfig: '获取配置',
		check: '终端自检'
	},
	widgetForm: {
		name: '名称',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			name: '请输入名称'
		}
	},
	terminal: {
		selectTerminal: '选择终端',
		config: '采集配置',
		sleepTime: '休眠时间',
		charValue: '特征值',
		wave: '波形',
		charValueLength: '特征值采集长度',
		charValueFreq: '特征值采集频率',
		highAccelLength: '高频加速度采集长度',
		highAccelFreq: '高频加速度采集频率',
		lowAccelLength: '低频加速度采集长度',
		lowAccelFreq: '低频加速度采集频率',
		longWaveLength: '长波形采集长度',
		longWaveFreq: '长波形采集频率',
		waveSampleInterval: '波形采样间隔',
		longWaveInterval: '长波形采样间隔',
		rpmChannel1: '转速 1 通道',
		rpmChannel2: '转速 2 通道',
		waveChannel: '波形上报通道',
		channel: '通道',
		sensitivity: '灵敏度',
		online: '在线',
		offline: '离线',
		normal: '正常',
		abnormal: '异常'
	},
	configSection: {
		config: '配置',
		sleepConfig: '休眠配置',
		charValueConfig: '特征值配置',
		waveConfig: '波形配置',
		channelConfig: '通道配置',
		collectLength: '采集长度',
		collectFreq: '采集频率',
		highLength: '高频长度',
		highFreq: '高频频率',
		lowLength: '低频长度',
		lowFreq: '低频频率',
		longLength: '长波形长度',
		longFreq: '长波形频率',
		waveInterval: '波形间隔',
		longWaveInterval: '长波形间隔',
		rpm1Channel: '转速 1 通道',
		rpm2Channel: '转速 2 通道',
		waveChannels: '波形通道'
	},
	timeUnit: {
		second: '秒',
		minute: '分钟',
		hour: '小时',
		day: '天',
		s: '秒',
		min: '分钟',
		h: '小时',
		d: '天'
	},
	buttons: {
		getConfig: '获取配置',
		selfCheck: '终端自检',
		send: '下发',
		setSensitivity: '灵敏度下发',
		getWave: '获取波形',
		confirm: '确定',
		cancel: '取消'
	},
	options: {
		sleep: '休眠时间',
		spec: '特征值',
		wave: '波形',
		sleep_time: '休眠时间',
		spec_length: '特征值采集长度',
		spec_freq: '特征值采集频率',
		high_length: '高频加速度采集长度',
		high_freq: '高频加速度采集频率',
		low_length: '低频加速度采集长度',
		low_freq: '低频加速度采集频率',
		long_length: '长波形采集长度',
		long_freq: '长波形采集频率',
		wave_time: '波形采样间隔',
		long_wave_time: '长波形采样间隔',
		rpm1: '转速 1 通道',
		rpm2: '转速 2 通道',
		channels: '波形上报通道',
		timeOptions: {
			'10s': '10 秒',
			'20s': '20 秒',
			'30s': '30 秒',
			'1min': '1 分钟',
			'5min': '5 分钟',
			'10min': '10 分钟',
			'20min': '20 分钟',
			'30min': '30 分钟',
			'1h': '1 小时',
			'2h': '2 小时',
			'4h': '4 小时',
			'6h': '6 小时',
			'12h': '12 小时',
			'1d': '1 天',
			'2d': '2 天',
			'3d': '3 天',
			'4d': '4 天'
		},
		lengthOptions: {
			'1K': '1K',
			'2K': '2K',
			'4K': '4K',
			'8K': '8K',
			'16K': '16K',
			'32K': '32K',
			'64K': '64K',
			'128K': '128K',
			'256K': '256K',
			'512K': '512K',
			'2048K': '2048K'
		},
		freqOptions: {
			'2560': '2560',
			'5120': '5120',
			'12800': '12800',
			'25600': '25600',
			'51200': '51200'
		}
	}
}
